import $ from 'jquery';
import '@fancyapps/fancybox';
import 'slick-carousel';
import tippy from 'tippy.js';
import headerCartRefresh from './headerCartRefresh';
import initAjaxCart from './ajaxCartInit';

export const init = () => {

	var request = null;

	$(document)
		.on('submit', '.f-add-to-cart', function(e) {

			e.preventDefault();

			var $this = $(this);
			let tip = null;
			let btn = null;

			if (request != null) {
				request.abort();
			}

			request = $.ajax({
				url: $this.attr('action'),
				data: $this.serialize(),

				beforeSend: function() {
					$this.addClass('is-loading');
				},
			})
				.done(function(response) {
					$this.removeClass('is-loading');

					request = null;

					if ($this.is(':not(.f-add-to-cart--tooltip)')) {
						var $fancybox = $.fancybox.open( response, {
							btnTpl: {
								smallBtn: '<button data-fancybox-close class="fancybox-close-small" title="{{CLOSE}}"><svg version="1.1" id="Vrstva_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 15 15" style="enable-background:new 0 0 15 15;" xml:space="preserve"><path class="st0" fill="#576371" d="M9.6,7.5l4.9-4.9c0.4-0.4,0.4-1,0-1.4l-0.6-0.6c-0.4-0.4-1-0.4-1.4,0L7.5,5.4L2.6,0.5c-0.4-0.4-1-0.4-1.4,0 L0.5,1.1c-0.4,0.4-0.4,1,0,1.4l4.9,4.9l-4.9,4.9c-0.4,0.4-0.4,1,0,1.4l0.6,0.6c0.4,0.4,1,0.4,1.4,0l4.9-4.9l4.9,4.9 c0.4,0.4,1,0.4,1.4,0l0.6-0.6c0.4-0.4,0.4-1,0-1.4L9.6,7.5z"/></svg></button>',
							},
							touch: false,
						});

						$fancybox.current.$content.trigger('contentload');
						initAjaxCart();
						headerCartRefresh();

					} else {
						btn = $this.find('.f-add-to-cart__btn').get(0);
						const data = $this.data('tippy');

						if (data == null) {
							tip = tippy.one(btn, {
								animation: 'shift-toward',
								arrow: true,
								arrowType: 'sharp',
								arrowTransform: 'scaleX(1.3)',
								duration: 500,
								size: 'large',
								placement: 'bottom',
								position: 'bottom-start',
								theme: 'light',
								hideOnClick: false,
								trigger: 'manual',
								dynamicTitle: true,
							});
							tip.show();

							$this.data('tippy', {
								tip,
								btn,
								timer: setTimeout(() => {
									tip.hide();
								}, 2000),
							});

						} else {

							clearTimeout(data.timer);
							data.btn.title = 'Nový údaj o počtu kusů v košíku';
							data.tip.show();

							data.timer = setTimeout(() => {
								data.tip.hide();
							}, 2000);

						}
					}

				});
		});

};
